import { render, staticRenderFns } from "./AreaFormDialog.vue?vue&type=template&id=608b1dc2&scoped=true"
import script from "./AreaFormDialog.vue?vue&type=script&lang=js"
export * from "./AreaFormDialog.vue?vue&type=script&lang=js"
import style0 from "./AreaFormDialog.vue?vue&type=style&index=0&id=608b1dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608b1dc2",
  null
  
)

export default component.exports